import React, { useState, useContext } from "react";
import { ThemeContext } from "../../../../context/ThemeContext";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const LocationIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// DEMO DATA
// ─────────────────────────────────────────────────────────────────────────────
const demoEnquiries = [
  { id: 31, name: "Ram Sharma", phone: "7974442307", date: "4/21/2026", location: "", type: "Franchise", status: "Pending" },
  { id: 30, name: "Ram", phone: "7974442307", date: "4/4/2026", location: "Gwalior, Madhya Pradesh", type: "Franchise", status: "Pending" },
  { id: 29, name: "Neeraj Verma", phone: "09109747086", date: "4/4/2026", location: "Gwalior, Madhya Pradesh", type: "Franchise", status: "Pending" },
  { id: 28, name: "Yash Suri", phone: "09300018690", date: "4/3/2026", location: "Gwalior, Madhya Pradesh", type: "Franchise", status: "Pending" },
  { id: 27, name: "Rohit Sharma", phone: "9876543210", date: "4/2/2026", location: "Delhi", type: "Delivery", status: "Pending" },
  { id: 26, name: "Amit Kumar", phone: "9876543211", date: "4/1/2026", location: "Noida", type: "Restaurant", status: "Pending" },
  { id: 25, name: "Priya Singh", phone: "9876543212", date: "3/31/2026", location: "Ghaziabad", type: "Sales Team", status: "Pending" },
  { id: 24, name: "Contact Us", phone: "9876543213", date: "3/30/2026", location: "", type: "Contact", status: "Pending" },
];

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────

const Checkbox = ({ checked, onChange, theme }) => (
  <div
    onClick={onChange}
    style={{
      width: "18px",
      height: "18px",
      borderRadius: "4px",
      border: checked
        ? `2px solid ${theme.primary}`
        : `2px solid ${theme.border}`,
      background: checked ? theme.primary : "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.2s ease",
    }}
  >
    {checked && (
      <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
        <path
          d="M2 6l3 3 5-5"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    )}
  </div>
);

const StatusBadge = ({ status, theme }) => {
  const config = {
    Pending: { bg: `${theme.warning}1a`, color: theme.warning },
    Approved: { bg: `${theme.success}1a`, color: theme.success },
    Rejected: { bg: `${theme.error || theme.danger}1a`, color: theme.error || theme.danger },
  };
  const c = config[status] || config.Pending;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "4px 12px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: 600,
        background: c.bg,
        color: c.color,
      }}
    >
      <span
        style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          background: c.color,
        }}
      />
      {status}
    </span>
  );
};

const TypeBadge = ({ type, theme }) => {
  const config = {
    Franchise: { bg: `${theme.primary}1a`, color: theme.primary },
    Delivery: { bg: `${theme.success}1a`, color: theme.success },
    Restaurant: { bg: `${theme.warning}1a`, color: theme.warning },
    "Sales Team": { bg: `#8b5cf61a`, color: "#8b5cf6" },
    Contact: { bg: `#ec48991a`, color: "#ec4899" },
  };
  const c = config[type] || config.Franchise;
  return (
    <span
      style={{
        padding: "2px 8px",
        borderRadius: "10px",
        fontSize: "10px",
        fontWeight: 600,
        background: c.bg,
        color: c.color,
      }}
    >
      {type}
    </span>
  );
};

const StatCard = ({ title, count, newCount, color, theme, icon }) => (
  <div
    style={{
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "14px",
      padding: "18px 20px",
      textAlign: "center",
      flex: 1,
      minWidth: "140px",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      cursor: "pointer",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow = `0 8px 20px ${color}15`;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
  >
    <div
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "10px",
        background: `${color}1a`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: color,
        margin: "0 auto 12px",
        fontSize: "18px",
      }}
    >
      {icon}
    </div>
    <div style={{ fontSize: "28px", fontWeight: 700, color: theme.textPrimary }}>
      {count}
    </div>
    <div
      style={{
        fontSize: "11px",
        fontWeight: 500,
        color: theme.textMuted,
        marginTop: "4px",
      }}
    >
      {title}
    </div>
    <div
      style={{
        fontSize: "10px",
        fontWeight: 600,
        color: color,
        marginTop: "6px",
        background: `${color}15`,
        padding: "2px 8px",
        borderRadius: "10px",
        display: "inline-block",
      }}
    >
      +{newCount} new
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const Enquiries = () => {
  const { theme } = useContext(ThemeContext); // ← Theme Context
  
  const [enquiries, setEnquiries] = useState(demoEnquiries);
  const [selected, setSelected] = useState(new Set());
  const [selectedType, setSelectedType] = useState("All");

  // Calculate stats
  const stats = {
    franchise: {
      count: enquiries.filter((e) => e.type === "Franchise").length,
      new: 31,
    },
    delivery: {
      count: enquiries.filter((e) => e.type === "Delivery").length,
      new: 4,
    },
    restaurant: {
      count: enquiries.filter((e) => e.type === "Restaurant").length,
      new: 228,
    },
    salesTeam: {
      count: enquiries.filter((e) => e.type === "Sales Team").length,
      new: 9,
    },
    contact: {
      count: enquiries.filter((e) => e.type === "Contact").length,
      new: 82,
    },
  };

  // Filter by type
  const filteredEnquiries =
    selectedType === "All"
      ? enquiries
      : enquiries.filter((e) => e.type === selectedType);

  // Selection handlers
  const toggleAll = () => {
    if (selected.size === filteredEnquiries.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(filteredEnquiries.map((e) => e.id)));
    }
  };

  const toggleOne = (id) => {
    const newSelected = new Set(selected);
    newSelected.has(id) ? newSelected.delete(id) : newSelected.add(id);
    setSelected(newSelected);
  };

  const handleEdit = (enquiry) => {
    alert(`Edit enquiry: ${enquiry.name}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this enquiry?")) {
      setEnquiries((prev) => prev.filter((e) => e.id !== id));
      setSelected((prev) => {
        const newSet = new Set(prev);
        newSet.delete(id);
        return newSet;
      });
    }
  };

  const handleView = (enquiry) => {
    alert(
      `View enquiry\nName: ${enquiry.name}\nPhone: ${enquiry.phone}\nDate: ${enquiry.date}\nLocation: ${enquiry.location || "N/A"}`
    );
  };

  const styles = {
    container: {
      background: "transparent",
      fontFamily: "'Segoe UI', 'DM Sans', sans-serif",
      padding: "20px 24px",
    },
    statsRow: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "12px",
      marginBottom: "24px",
    },
    typeFilters: {
      display: "flex",
      gap: "8px",
      marginBottom: "20px",
      flexWrap: "wrap",
      padding: "6px",
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "12px",
      width: "fit-content",
    },
    typeBtn: (isActive) => ({
      padding: "8px 18px",
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: 500,
      background: isActive ? theme.primary : "transparent",
      color: isActive ? "#fff" : theme.textSecondary,
      border: "none",
      cursor: "pointer",
      transition: "all 0.2s ease",
    }),
    selectionBar: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "12px 16px",
      marginBottom: "16px",
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
    },
    enquiriesList: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    enquiryItem: (isSelected) => ({
      display: "flex",
      alignItems: "center",
      gap: "16px",
      padding: "14px 16px",
      background: isSelected ? `${theme.primary}08` : theme.surface,
      border: `1px solid ${isSelected ? `${theme.primary}40` : theme.border}`,
      borderRadius: "10px",
      transition: "all 0.2s ease",
    }),
    enquiryContent: {
      flex: 1,
    },
    enquiryName: {
      fontSize: "15px",
      fontWeight: 600,
      color: theme.textPrimary,
      marginBottom: "4px",
    },
    enquiryDetails: {
      fontSize: "12px",
      color: theme.textSecondary,
      display: "flex",
      alignItems: "center",
      gap: "12px",
      flexWrap: "wrap",
      marginTop: "4px",
    },
    detailItem: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },
    enquiryId: {
      fontSize: "11px",
      fontWeight: 700,
      color: theme.primary,
      fontFamily: "monospace",
      minWidth: "35px",
      padding: "4px 8px",
      background: `${theme.primary}15`,
      borderRadius: "6px",
      textAlign: "center",
    },
    actions: {
      display: "flex",
      gap: "6px",
      alignItems: "center",
    },
    actionBtn: {
      background: "none",
      border: `1px solid ${theme.border}`,
      cursor: "pointer",
      padding: "6px",
      color: theme.textSecondary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "6px",
      transition: "all 0.2s ease",
    },
    emptyState: {
      textAlign: "center",
      padding: "60px",
      color: theme.textMuted,
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>

      {/* Stats Cards */}
      <div style={styles.statsRow}>
        <StatCard
          title="Franchise"
          count={stats.franchise.count}
          newCount={stats.franchise.new}
          color={theme.primary}
          theme={theme}
          icon="🏪"
        />
        <StatCard
          title="Delivery"
          count={stats.delivery.count}
          newCount={stats.delivery.new}
          color={theme.success}
          theme={theme}
          icon="🚴"
        />
        <StatCard
          title="Restaurant"
          count={stats.restaurant.count}
          newCount={stats.restaurant.new}
          color={theme.warning}
          theme={theme}
          icon="🍽️"
        />
        <StatCard
          title="Sales Team"
          count={stats.salesTeam.count}
          newCount={stats.salesTeam.new}
          color="#8b5cf6"
          theme={theme}
          icon="👥"
        />
        <StatCard
          title="Contact"
          count={stats.contact.count}
          newCount={stats.contact.new}
          color="#ec4899"
          theme={theme}
          icon="📞"
        />
      </div>

      {/* Type Filters */}
      <div style={styles.typeFilters}>
        {[
          "All",
          "Franchise",
          "Delivery",
          "Restaurant",
          "Sales Team",
          "Contact",
        ].map((type) => (
          <button
            key={type}
            style={styles.typeBtn(selectedType === type)}
            onClick={() => setSelectedType(type)}
            onMouseEnter={(e) => {
              if (selectedType !== type) {
                e.currentTarget.style.background = theme.surfaceLighter;
              }
            }}
            onMouseLeave={(e) => {
              if (selectedType !== type) {
                e.currentTarget.style.background = "transparent";
              }
            }}
          >
            {type}
          </button>
        ))}
      </div>

      {/* Selection Bar */}
      <div style={styles.selectionBar}>
        <Checkbox
          checked={
            selected.size === filteredEnquiries.length &&
            filteredEnquiries.length > 0
          }
          onChange={toggleAll}
          theme={theme}
        />
        <span
          style={{
            fontSize: "13px",
            color: theme.textPrimary,
            fontWeight: 500,
          }}
        >
          Select all ({filteredEnquiries.length})
        </span>
        {selected.size > 0 && (
          <span
            style={{
              fontSize: "12px",
              color: theme.primary,
              marginLeft: "auto",
              fontWeight: 600,
              background: `${theme.primary}15`,
              padding: "4px 12px",
              borderRadius: "20px",
            }}
          >
            {selected.size} selected
          </span>
        )}
      </div>

      {/* Enquiries List */}
      <div style={styles.enquiriesList}>
        {filteredEnquiries.length === 0 ? (
          <div style={styles.emptyState}>
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: `${theme.primary}1a`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: "32px",
              }}
            >
              📭
            </div>
            <h3
              style={{
                color: theme.textPrimary,
                marginBottom: "8px",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              No Enquiries Found
            </h3>
            <p style={{ color: theme.textMuted, fontSize: "13px", margin: 0 }}>
              No enquiries match the selected filter
            </p>
          </div>
        ) : (
          filteredEnquiries.map((enquiry) => {
            const isSelected = selected.has(enquiry.id);
            return (
              <div
                key={enquiry.id}
                style={styles.enquiryItem(isSelected)}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}10`;
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <Checkbox
                  checked={isSelected}
                  onChange={() => toggleOne(enquiry.id)}
                  theme={theme}
                />
                <div style={styles.enquiryId}>#{enquiry.id}</div>
                <div style={styles.enquiryContent}>
                  <div style={styles.enquiryName}>
                    {enquiry.name}
                    <span style={{ marginLeft: "8px" }}>
                      <TypeBadge type={enquiry.type} theme={theme} />
                    </span>
                  </div>
                  <div style={styles.enquiryDetails}>
                    <span style={styles.detailItem}>
                      <PhoneIcon />
                      {enquiry.phone}
                    </span>
                    <span style={styles.detailItem}>
                      <CalendarIcon />
                      {enquiry.date}
                    </span>
                    {enquiry.location && (
                      <span style={styles.detailItem}>
                        <LocationIcon />
                        {enquiry.location}
                      </span>
                    )}
                  </div>
                </div>
                <div style={styles.actions}>
                  <StatusBadge status={enquiry.status} theme={theme} />
                  <button
                    style={styles.actionBtn}
                    onClick={() => handleView(enquiry)}
                    title="View"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = `${theme.primary}1a`;
                      e.currentTarget.style.color = theme.primary;
                      e.currentTarget.style.borderColor = theme.primary;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "none";
                      e.currentTarget.style.color = theme.textSecondary;
                      e.currentTarget.style.borderColor = theme.border;
                    }}
                  >
                    <EyeIcon />
                  </button>
                  <button
                    style={styles.actionBtn}
                    onClick={() => handleEdit(enquiry)}
                    title="Edit"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = `${theme.warning}1a`;
                      e.currentTarget.style.color = theme.warning;
                      e.currentTarget.style.borderColor = theme.warning;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "none";
                      e.currentTarget.style.color = theme.textSecondary;
                      e.currentTarget.style.borderColor = theme.border;
                    }}
                  >
                    <EditIcon />
                  </button>
                  <button
                    style={styles.actionBtn}
                    onClick={() => handleDelete(enquiry.id)}
                    title="Delete"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = `${theme.error || theme.danger}1a`;
                      e.currentTarget.style.color = theme.error || theme.danger;
                      e.currentTarget.style.borderColor = theme.error || theme.danger;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "none";
                      e.currentTarget.style.color = theme.textSecondary;
                      e.currentTarget.style.borderColor = theme.border;
                    }}
                  >
                    <DeleteIcon />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Enquiries;